import { gql } from "@apollo/client";

export const GET_USER_COOKIE_CHOICE = gql`
  query getUserCookieChoice {
    getUserCookieChoice {
      cookie
    }
  }
`;
